import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  addProductOption: () => __(translations.commercialDocumentComponents.addProductOption, 'Add Option'),
  addProductComponent: () => __(translations.commercialDocumentComponents.addProductComponent, 'Add Component'),
};
